import { render, staticRenderFns } from "./premises.vue?vue&type=template&id=491b6a44&"
import script from "./premises.vue?vue&type=script&lang=js&"
export * from "./premises.vue?vue&type=script&lang=js&"
import style0 from "./premises.vue?vue&type=style&index=0&id=491b6a44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports